import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HttpBypassInterceptorClientService } from './services/http-bypass-interceptor-client.service';
import { RequestCacheService } from './caching/request-cache.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpInterceptorProviders } from './http-interceptors';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AlertComponent } from './alert/alert.component';
import { AlertService } from '../shared/services/alert.service';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule } from '@angular/common';
import { DialogService } from '../shared/services/dialog.service';
import { WindowWrapper } from '../content-list-management/shared/wrappers/window-wrapper';
import { FeatureFlagsService } from './feature-flags/feature-flag.service';

@NgModule({
  declarations: [DashboardComponent, SidebarComponent, AlertComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatListModule,
    MatIconModule,
    MatToolbarModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
  ],
  providers: [
    FeatureFlagsService,
    CookieService,
    HttpBypassInterceptorClientService,
    HttpInterceptorProviders,
    RequestCacheService,
    AlertService,
    DialogService,
    { provide: WindowWrapper, useValue: window },
  ],
})
export class CoreModule {}
